import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start text-lg" }, "Criar usuário", -1)
const _hoisted_2 = {
  key: 1,
  class: "text-grey text-caption align-self-center ml-2"
}
const _hoisted_3 = { class: "font-weight-medium" }
const _hoisted_4 = {
  class: "text-grey-lighten-1 font-weight-regular",
  style: {"font-size":"0.65rem"}
}
const _hoisted_5 = {
  key: 0,
  class: "pa-4 d-flex justify-center"
}

import { computed, reactive, ref, watch } from 'vue'
import { VForm } from 'vuetify/components'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'
import { storeToRefs } from 'pinia'
import { useCompanyStore } from '@/pinia-store/useCompanyStore'
import Network from '@/Network'
import { useToast } from 'vue-toastification'
import { useErrorToast } from '@/composables/useErrorToast'
import GenericInput from '@/components/designSystem/Inputs/GenericInput.vue'
import { useGroupStore } from '@/pinia-store/useGroupStore'
import { Intersect as vIntersect } from 'vuetify/directives'


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  props: {
    modalActive: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: emits }) {




const formRef = ref<InstanceType<typeof VForm> | null>(null)
const loading = ref(false)
const { listCompanies } = storeToRefs(useCompanyStore())
const groupStore = useGroupStore()
const { filteredGroups, isLoading: isGroupsLoading } = storeToRefs(groupStore)
const toast = useToast()
const { notifyError } = useErrorToast()

const getInitialFormState = () => ({
  name: '',
  email: '',
  password: '',
  confirmPassword: '',
  phone1: '',
  registration: '',
  fullAccess: false,
  sendWelcomeEmail: true,
  companies: [] as string[],
  groups: [] as number[]
})
const form = reactive(getInitialFormState())

// A store relança a falha da listagem de grupos; aqui ela vira aviso e o select fica como está.
const loadGroups = async (companyIds: number[], page: number) => {
  try {
    await groupStore.fetchByCompanies(companyIds, page)
  } catch (error) {
    notifyError(error, 'Não foi possível carregar os grupos das empresas selecionadas.')
  }
}

const groupOptions = computed(() => {
  return (groupStore.filteredGroups || []).map((group) => ({
    title: group.name,
    value: group.id,
    groupId: group.id,
    groupName: group.name,
    companyName: group.company?.name || 'Empresa não encontrada',
    raw: group
  }))
})

const rules = {
  required: (v: any) => !!v || 'Campo obrigatório',
  requiredList: (v: any[]) => (v && v.length > 0) || 'Selecione pelo menos uma empresa',
  name: (v: string) => (v && v.length >= 3) || 'Nome deve ter no mínimo 3 caracteres',
  email: (v: string) => /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i.test(v) || 'E-mail inválido',
  phone: (v: string) => (v && v.length === 15) || 'Telefone inválido',
  password: (v: string) =>
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[$*&@#])[0-9a-zA-Z$*&@#]{8,}$/.test(v) ||
    'Senha fraca (mín. 8 caracteres, 1 maiúscula, 1 minúscula, 1 número, 1 especial)',
  confirmPassword: (v: string) => v === form.password || 'As senhas não conferem'
}

watch(
  () => form.sendWelcomeEmail,
  (isSendEmail) => {
    if (isSendEmail) {
      form.password = ''
      form.confirmPassword = ''
      formRef.value?.resetValidation()
    }
  }
)

watch(
  () => form.companies,
  async (newCompanies) => {
    form.groups = []
    groupStore.currentPage = 1
    if (newCompanies && newCompanies.length > 0) {
      const companyIds = newCompanies.map((id) => Number(id))
      await loadGroups(companyIds, 1)
    } else {
      groupStore.filteredGroups = []
    }
  }
)

const resetForm = () => {
  Object.assign(form, getInitialFormState())
  loadGroups([], 1)
  formRef.value?.reset()
}

const close = () => {
  resetForm()
  emits('close')
}

const hasMoreGroups = computed(() => {
  return filteredGroups.value.length < groupStore.totalCount
})

const onIntersect = async (isIntersecting: boolean) => {
  if (!isIntersecting || isGroupsLoading.value || !hasMoreGroups.value) return
  const nextPage = groupStore.currentPage + 1
  if (filteredGroups.value.length >= groupStore.totalCount) return
  const companyIds = form.companies.map((id) => Number(id))
  await loadGroups(companyIds, nextPage)
}

const removeGroup = (id: number) => {
  form.groups = form.groups.filter((groupId) => groupId !== id)
}

const createUser = async () => {
  if (!formRef.value) return

  const { valid } = await formRef.value.validate()

  if (!valid) {
    toast.warning('Por favor, preencha corretamente os campos obrigatórios.')
    return
  }

  try {
    loading.value = true
    await Network.company.createCompanyUser({
      companies: form.companies.map((id) => Number(id)),
      companyId: Number(form.companies[0]),
      name: form.name,
      email: form.email,
      phone: form.phone1.replace(/\D/g, ''),
      registration: form.registration || undefined,
      password: form.password,
      confirmPassword: form.confirmPassword,
      fullAccess: form.fullAccess,
      sendWelcomeEmail: form.sendWelcomeEmail,
      groups: form.groups || []
    })
    toast.success('Usuário cadastrado com sucesso!')
    close()
  } catch (e) {
    // Antes: `e.response?.data?.message` extraído na mão — com o `ServiceError`
    // do service migrado o cast deixaria de casar e a mensagem do backend sumiria.
    notifyError(e, 'Não foi possível cadastrar o usuário. Verifique os dados e tente novamente.')
  } finally {
    loading.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_checkbox_btn = _resolveComponent("v-checkbox-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_row = _resolveComponent("v-row")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: close,
    modalActive: _ctx.modalActive,
    "has-header-border": true,
    "has-footer-border": true
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_v_row, {
        dense: "",
        justify: "end"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(OutlineButton, {
                onClick: close,
                text: "Cancelar",
                width: "140px"
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            md: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(FilledButton, {
                loading: loading.value,
                onClick: createUser,
                text: "Criar",
                width: "140px",
                type: "submit"
              }, null, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(VForm), {
        ref_key: "formRef",
        ref: formRef,
        onSubmit: _withModifiers(createUser, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            dense: "",
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(GenericInput, {
                    modelValue: form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.name) = $event)),
                    label: "Nome*",
                    rules: [rules.required, rules.name],
                    variant: "outlined"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(GenericInput, {
                    modelValue: form.email,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.email) = $event)),
                    label: "Email*",
                    rules: [rules.required, rules.email],
                    variant: "outlined"
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(GenericInput, {
                    modelValue: form.phone1,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.phone1) = $event)),
                    label: "Telefone*",
                    rules: [rules.required, rules.phone],
                    variant: "outlined"
                  }, null, 8, ["modelValue", "rules"]), [
                    [_directive_maska, '(##) #####-####']
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(GenericInput, {
                    modelValue: form.registration,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.registration) = $event)),
                    label: "Matrícula",
                    rules: [],
                    variant: "outlined"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(GenericInput, {
                    modelValue: form.password,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.password) = $event)),
                    disabled: form.sendWelcomeEmail,
                    rules: form.sendWelcomeEmail ? [] : [rules.required, rules.password],
                    label: "Senha",
                    type: "password",
                    variant: "outlined"
                  }, null, 8, ["modelValue", "disabled", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(GenericInput, {
                    modelValue: form.confirmPassword,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.confirmPassword) = $event)),
                    disabled: form.sendWelcomeEmail,
                    rules: form.sendWelcomeEmail ? [] : [rules.required, rules.confirmPassword],
                    label: "Confirmar senha",
                    type: "password",
                    variant: "outlined"
                  }, null, 8, ["modelValue", "disabled", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: form.companies,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.companies) = $event)),
                    color: "primary20",
                    label: "Empresas*",
                    items: _unref(listCompanies),
                    "item-title": "title",
                    "item-value": "value",
                    multiple: "",
                    chips: "",
                    "closable-chips": "",
                    rules: [rules.requiredList],
                    variant: "outlined"
                  }, null, 8, ["modelValue", "items", "rules"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_autocomplete, {
                    modelValue: form.groups,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.groups) = $event)),
                    color: "primary20",
                    label: "Grupos",
                    items: groupOptions.value,
                    loading: _unref(isGroupsLoading),
                    disabled: form.companies.length === 0,
                    "item-title": "title",
                    "item-value": "value",
                    multiple: "",
                    clearable: "",
                    placeholder: "Selecione os grupos (opcional)",
                    "no-data-text": "Nenhum grupo encontrado para as empresas selecionadas",
                    rules: [],
                    variant: "outlined"
                  }, {
                    selection: _withCtx(({ item, index }) => [
                      (index < 4)
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            closable: "",
                            "onClick:close": ($event: any) => (removeGroup(item.raw.groupId))
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("span", null, _toDisplayString(item.raw.groupName), 1)
                            ]),
                            _: 2
                          }, 1032, ["onClick:close"]))
                        : _createCommentVNode("", true),
                      (index === 4)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " (+" + _toDisplayString(form.groups.length - 4) + ") ", 1))
                        : _createCommentVNode("", true)
                    ]),
                    item: _withCtx(({ props, item }) => [
                      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                        prepend: _withCtx(() => [
                          _createVNode(_component_v_checkbox_btn, {
                            "model-value": form.groups.includes(item.value),
                            "pointer-events": "none"
                          }, null, 8, ["model-value"])
                        ]),
                        title: _withCtx(() => [
                          _createElementVNode("span", _hoisted_3, _toDisplayString(item.raw.groupName), 1)
                        ]),
                        append: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, " Empresa: " + _toDisplayString(item.raw.companyName), 1)
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    "append-item": _withCtx(() => [
                      (hasMoreGroups.value)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                            (_unref(isGroupsLoading))
                              ? (_openBlock(), _createBlock(_component_v_progress_circular, {
                                  key: 0,
                                  indeterminate: "",
                                  size: "20",
                                  color: "primary"
                                }))
                              : _createCommentVNode("", true)
                          ])), [
                            [_unref(vIntersect), { handler: onIntersect, options: { threshold: 0.5 } }]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue", "items", "loading", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_checkbox, {
                    modelValue: form.sendWelcomeEmail,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.sendWelcomeEmail) = $event)),
                    "hide-details": "",
                    label: "Enviar e-mail de boas-vindas com as credenciais para o novo usuário"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})